export default (function (value) {
  if (typeof value !== 'object' || value === null) return false;
  var proto = value;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(value) === proto;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/es/utils/isPlainObject.js
// module id = 246
// module chunks = 2